// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Styles one collapsed left navigation rail item.
 * Keeps the item compact while giving active state a stronger icon-tile treatment.
 */
.left-nav-rail-item {
  position: relative;
  width: calc(100% - 0.5rem);
  min-height: var(--left-nav-rail-item-min-height, 4.6rem);
  border: 0;
  background: transparent;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--left-nav-item-gap, 0.3rem);
  padding: clamp(0.35rem, 0.75vh, 0.6rem) 0.25rem;
  color: #334155;
  cursor: pointer;
  border-radius: 0.9rem;
  transition: background-color 120ms ease, color 120ms ease, transform 120ms ease;
}

.left-nav-rail-item--active {
  color: #0f2f52;
}

.left-nav-rail-item__icon-tile {
  position: relative;
  width: 3.25rem;
  height: 3.25rem;
  border-radius: 0.875rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  overflow: hidden;
  transition: background-color 120ms ease, box-shadow 120ms ease, transform 120ms ease;
  flex: 0 0 auto;
}

.left-nav-rail-item__icon {
  display: block;
  width: var(--left-nav-current-icon-size, var(--left-nav-rail-icon-size, 2rem));
  height: var(--left-nav-current-icon-size, var(--left-nav-rail-icon-size, 2rem));
  object-fit: contain;
  filter: none;
  transition: filter 120ms ease, transform 120ms ease;
}

.left-nav-rail-item__label {
  font-size: var(--left-nav-label-size, 0.78rem);
  line-height: 1.1;
  text-align: center;
  white-space: nowrap;
  color: #475569;
  font-weight: 500;
  transition: color 120ms ease, font-weight 120ms ease;
}

.left-nav-rail-item:hover .left-nav-rail-item__icon-tile,
.left-nav-rail-item:focus-visible .left-nav-rail-item__icon-tile {
  background: #2f7198;
}

.left-nav-rail-item:hover .left-nav-rail-item__icon,
.left-nav-rail-item:focus-visible .left-nav-rail-item__icon {
  filter: brightness(0) invert(1);
}

.left-nav-rail-item--active .left-nav-rail-item__icon-tile {
  background: linear-gradient(180deg, #004d80 0%, #004d80 100%);
  box-shadow: 0 10px 18px rgba(47, 111, 237, 0.24);
  transform: translateY(-1px);
}

.left-nav-rail-item--active:hover .left-nav-rail-item__icon-tile,
.left-nav-rail-item--active:focus-visible .left-nav-rail-item__icon-tile {
  background: linear-gradient(180deg, #004d80 0%, #004d80 100%);
  box-shadow: 0 10px 18px rgba(47, 111, 237, 0.24);
}

.left-nav-rail-item--active .left-nav-rail-item__icon {
  filter: brightness(0) invert(1);
}

.left-nav-rail-item--active:hover .left-nav-rail-item__icon,
.left-nav-rail-item--active:focus-visible .left-nav-rail-item__icon {
  filter: brightness(0) invert(1);
}

.left-nav-rail-item--active .left-nav-rail-item__label {
  color: #0f172a;
  font-weight: 600;
}

.left-nav-rail-item__tooltip {
  position: absolute;
  left: calc(100% + 0.5rem);
  top: 50%;
  transform: translateY(-50%) translateX(-0.25rem);
  opacity: 0;
  pointer-events: none;
  white-space: nowrap;
  background: #0f172a;
  color: #f8fafc;
  border-radius: 0.375rem;
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  transition: opacity 140ms ease, transform 140ms ease;
  z-index: 5;
}

.left-nav-rail-item:hover .left-nav-rail-item__tooltip,
.left-nav-rail-item:focus-visible .left-nav-rail-item__tooltip {
  opacity: 1;
  transform: translateY(-50%) translateX(0);
}

@media (max-width: 768px) {
  .left-nav-rail-item__icon-tile {
    width: 3rem;
    height: 3rem;
  }
}
@media (max-height: 760px) {
  .left-nav-rail-item {
    min-height: var(--left-nav-rail-item-min-height, 4rem);
    padding-top: 0.3rem;
    padding-bottom: 0.3rem;
    gap: 0.2rem;
  }
  .left-nav-rail-item__icon-tile {
    width: clamp(2.75rem, 5.4vh, 3rem);
    height: clamp(2.75rem, 5.4vh, 3rem);
  }
  .left-nav-rail-item__label {
    font-size: 0.73rem;
  }
}
@media (max-height: 660px) {
  .left-nav-rail-item {
    min-height: var(--left-nav-rail-item-min-height, 3.6rem);
    padding-top: 0.22rem;
    padding-bottom: 0.22rem;
    gap: 0.12rem;
  }
  .left-nav-rail-item__icon-tile {
    width: clamp(2.5rem, 4.6vh, 2.85rem);
    height: clamp(2.5rem, 4.6vh, 2.85rem);
    border-radius: 0.8rem;
  }
  .left-nav-rail-item__icon {
    width: clamp(1.55rem, 3vh, 2rem);
    height: clamp(1.55rem, 3vh, 2rem);
  }
  .left-nav-rail-item__label {
    font-size: 0.68rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/modules/navigation/components/left-nav-rail-item/left-nav-rail-item.component.scss"],"names":[],"mappings":"AAAA;;;EAAA;AAIA;EACI,kBAAA;EACA,0BAAA;EACA,wDAAA;EACA,SAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,qCAAA;EACA,+CAAA;EACA,cAAA;EACA,eAAA;EACA,qBAAA;EACA,+EACI;AAAR;;AAKA;EACI,cAAA;AAFJ;;AAKA;EACI,kBAAA;EACA,cAAA;EACA,eAAA;EACA,uBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,gBAAA;EACA,oFACI;EAGJ,cAAA;AALJ;;AAQA;EACI,cAAA;EACA,8EAAA;EACA,+EAAA;EACA,mBAAA;EACA,YAAA;EACA,mDAAA;AALJ;;AAQA;EACI,8CAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,oDAAA;AALJ;;AAQA;;EAEI,mBAAA;AALJ;;AAQA;;EAEI,+BAAA;AALJ;;AAQA;EACI,6DAAA;EACA,gDAAA;EACA,2BAAA;AALJ;;AAQA;;EAEI,6DAAA;EACA,gDAAA;AALJ;;AAQA;EACI,+BAAA;AALJ;;AAQA;;EAEI,+BAAA;AALJ;;AAQA;EACI,cAAA;EACA,gBAAA;AALJ;;AAQA;EACI,kBAAA;EACA,yBAAA;EACA,QAAA;EACA,gDAAA;EACA,UAAA;EACA,oBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,uBAAA;EACA,uBAAA;EACA,kBAAA;EACA,oDAAA;EACA,UAAA;AALJ;;AAQA;;EAEI,UAAA;EACA,yCAAA;AALJ;;AAQA;EACI;IACI,WAAA;IACA,YAAA;EALN;AACF;AAQA;EACI;IACI,sDAAA;IACA,mBAAA;IACA,sBAAA;IACA,WAAA;EANN;EASE;IACI,kCAAA;IACA,mCAAA;EAPN;EAUE;IACI,kBAAA;EARN;AACF;AAWA;EACI;IACI,wDAAA;IACA,oBAAA;IACA,uBAAA;IACA,YAAA;EATN;EAYE;IACI,oCAAA;IACA,qCAAA;IACA,qBAAA;EAVN;EAaE;IACI,gCAAA;IACA,iCAAA;EAXN;EAcE;IACI,kBAAA;EAZN;AACF","sourcesContent":["/**\n * Styles one collapsed left navigation rail item.\n * Keeps the item compact while giving active state a stronger icon-tile treatment.\n */\n.left-nav-rail-item {\n    position: relative;\n    width: calc(100% - 0.5rem);\n    min-height: var(--left-nav-rail-item-min-height, 4.6rem);\n    border: 0;\n    background: transparent;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: var(--left-nav-item-gap, 0.3rem);\n    padding: clamp(0.35rem, 0.75vh, 0.6rem) 0.25rem;\n    color: #334155;\n    cursor: pointer;\n    border-radius: 0.9rem;\n    transition:\n        background-color 120ms ease,\n        color 120ms ease,\n        transform 120ms ease;\n}\n\n.left-nav-rail-item--active {\n    color: #0f2f52;\n}\n\n.left-nav-rail-item__icon-tile {\n    position: relative;\n    width: 3.25rem;\n    height: 3.25rem;\n    border-radius: 0.875rem;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    background: transparent;\n    overflow: hidden;\n    transition:\n        background-color 120ms ease,\n        box-shadow 120ms ease,\n        transform 120ms ease;\n    flex: 0 0 auto;\n}\n\n.left-nav-rail-item__icon {\n    display: block;\n    width: var(--left-nav-current-icon-size, var(--left-nav-rail-icon-size, 2rem));\n    height: var(--left-nav-current-icon-size, var(--left-nav-rail-icon-size, 2rem));\n    object-fit: contain;\n    filter: none;\n    transition: filter 120ms ease, transform 120ms ease;\n}\n\n.left-nav-rail-item__label {\n    font-size: var(--left-nav-label-size, 0.78rem);\n    line-height: 1.1;\n    text-align: center;\n    white-space: nowrap;\n    color: #475569;\n    font-weight: 500;\n    transition: color 120ms ease, font-weight 120ms ease;\n}\n\n.left-nav-rail-item:hover .left-nav-rail-item__icon-tile,\n.left-nav-rail-item:focus-visible .left-nav-rail-item__icon-tile {\n    background: #2f7198;\n}\n\n.left-nav-rail-item:hover .left-nav-rail-item__icon,\n.left-nav-rail-item:focus-visible .left-nav-rail-item__icon {\n    filter: brightness(0) invert(1);\n}\n\n.left-nav-rail-item--active .left-nav-rail-item__icon-tile {\n    background: linear-gradient(180deg, #004d80 0%, #004d80 100%);\n    box-shadow: 0 10px 18px rgba(47, 111, 237, 0.24);\n    transform: translateY(-1px);\n}\n\n.left-nav-rail-item--active:hover .left-nav-rail-item__icon-tile,\n.left-nav-rail-item--active:focus-visible .left-nav-rail-item__icon-tile {\n    background: linear-gradient(180deg, #004d80 0%, #004d80 100%);\n    box-shadow: 0 10px 18px rgba(47, 111, 237, 0.24);\n}\n\n.left-nav-rail-item--active .left-nav-rail-item__icon {\n    filter: brightness(0) invert(1);\n}\n\n.left-nav-rail-item--active:hover .left-nav-rail-item__icon,\n.left-nav-rail-item--active:focus-visible .left-nav-rail-item__icon {\n    filter: brightness(0) invert(1);\n}\n\n.left-nav-rail-item--active .left-nav-rail-item__label {\n    color: #0f172a;\n    font-weight: 600;\n}\n\n.left-nav-rail-item__tooltip {\n    position: absolute;\n    left: calc(100% + 0.5rem);\n    top: 50%;\n    transform: translateY(-50%) translateX(-0.25rem);\n    opacity: 0;\n    pointer-events: none;\n    white-space: nowrap;\n    background: #0f172a;\n    color: #f8fafc;\n    border-radius: 0.375rem;\n    padding: 0.25rem 0.5rem;\n    font-size: 0.75rem;\n    transition: opacity 140ms ease, transform 140ms ease;\n    z-index: 5;\n}\n\n.left-nav-rail-item:hover .left-nav-rail-item__tooltip,\n.left-nav-rail-item:focus-visible .left-nav-rail-item__tooltip {\n    opacity: 1;\n    transform: translateY(-50%) translateX(0);\n}\n\n@media (max-width: 768px) {\n    .left-nav-rail-item__icon-tile {\n        width: 3rem;\n        height: 3rem;\n    }\n}\n\n@media (max-height: 760px) {\n    .left-nav-rail-item {\n        min-height: var(--left-nav-rail-item-min-height, 4rem);\n        padding-top: 0.3rem;\n        padding-bottom: 0.3rem;\n        gap: 0.2rem;\n    }\n\n    .left-nav-rail-item__icon-tile {\n        width: clamp(2.75rem, 5.4vh, 3rem);\n        height: clamp(2.75rem, 5.4vh, 3rem);\n    }\n\n    .left-nav-rail-item__label {\n        font-size: 0.73rem;\n    }\n}\n\n@media (max-height: 660px) {\n    .left-nav-rail-item {\n        min-height: var(--left-nav-rail-item-min-height, 3.6rem);\n        padding-top: 0.22rem;\n        padding-bottom: 0.22rem;\n        gap: 0.12rem;\n    }\n\n    .left-nav-rail-item__icon-tile {\n        width: clamp(2.5rem, 4.6vh, 2.85rem);\n        height: clamp(2.5rem, 4.6vh, 2.85rem);\n        border-radius: 0.8rem;\n    }\n\n    .left-nav-rail-item__icon {\n        width: clamp(1.55rem, 3vh, 2rem);\n        height: clamp(1.55rem, 3vh, 2rem);\n    }\n\n    .left-nav-rail-item__label {\n        font-size: 0.68rem;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
